// @cs2ts-begin-auto-generated - do not modify
export const StatusEnumDto = {
    ok: 'e4db1a09-8253-4b2e-82a4-a1eb98a4d13d',
    toCheck: 'ae9a7f89-dfab-4d40-b4d5-3e639673e44d',
    error: '3e61da34-f8b2-4290-829c-e3d65a6ba9f9',
};
// @cs2ts-end-auto-generated - do not modify
